/* External dependencies */
import { gql } from '@apollo/client';

export const updateUserForAdminMutation = gql`
  mutation updateUserForAdmin($input: UpdateUserForAdminInput!) {
    updateUserForAdmin(input: $input) {
      statusMessage
    }
  }
`;
